module.exports = __webpack_public_path__ + "img/logo1.c25e4e50.svg";